import React from "react";
import {Modal} from "react-bootstrap";
import {FadeLoader} from "react-spinners";

interface Props {
  show?: boolean;
  height?: string;
  width?: string;
  text?: string;
}

function WaitingModal({show, height, width, text}: Props) {
  const spinner = (
    <FadeLoader
      loading={true}
      height={height || "15px"}
      width={width || "5px"}
      radius="2px"
      margin="2px"
      color="var(--accent)"
    />
  );

  return (
    <Modal className="waiting-modal" show={show} centered>
      <Modal.Body className="waiting-modal-body">
        {text ? (
          // With a progress message, render a solid card so the text is
          // readable (the modal content itself is transparent by design).
          <div
            style={{
              backgroundColor: "var(--card)",
              borderRadius: "var(--radius-xl)",
              padding: "24px 32px",
              boxShadow: "var(--shadow-menu)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center"
            }}
          >
            {spinner}
            <div
              style={{
                marginTop: "14px",
                color: "var(--fg)",
                fontSize: "0.95rem",
                fontWeight: 500,
                textAlign: "center",
                maxWidth: "360px",
                whiteSpace: "pre-line"
              }}
            >
              {text}
            </div>
          </div>
        ) : (
          spinner
        )}
      </Modal.Body>
    </Modal>
  );
}

export default WaitingModal;
